module.exports = __webpack_public_path__ + "media/images/ECS_Logo_black-9080d7425bddddb97e0d609728bcc67a.png";